export default __webpack_public_path__ + "static/media/cactus.f8dfb89f.svg";